import React, { createContext, useContext } from 'react';
import type { ServerResolvedSources } from '../utils/data-sources/server/serverSeed';

export type { ServerResolvedSources };

const ServerResolvedSourcesContext = createContext<
  ServerResolvedSources | undefined
>(undefined);

/**
 * Hands the data sources the server resolved for this page to every
 * `DataSourceManagerProvider` below, so the browser does not fetch them
 * again. A host that renders the page on the server wraps the experience in
 * this provider with the `seed` its server-side resolution returned.
 */
export function ServerResolvedSourcesProvider({
  sources,
  children,
}: {
  readonly sources: ServerResolvedSources | undefined;
  readonly children: React.ReactNode;
}) {
  return (
    <ServerResolvedSourcesContext.Provider value={sources}>
      {children}
    </ServerResolvedSourcesContext.Provider>
  );
}

/** The server-resolved sources above this component, if any. */
export function useServerResolvedSources(): ServerResolvedSources | undefined {
  return useContext(ServerResolvedSourcesContext);
}
